import { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Skeleton,
  Alert,
} from "@mui/material";
import { getLegalPrivacy } from "../../services/api";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const response = await getLegalPrivacy();
        if (response.data.status === "success") {
          setPolicy(response.data.data);
        }
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Failed to load privacy policy. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Paper sx={{ p: 3, my: 3 }}>
          <Skeleton height={40} width="60%" />
          <Skeleton height={20} width="30%" sx={{ mb: 2 }} />
          <Skeleton height={100} />
          <Skeleton height={100} />
          <Skeleton height={100} />
        </Paper>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Alert severity="error" sx={{ my: 3 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, my: 3 }}>
        <Box
          sx={{
            "& h1": {
              fontSize: "2rem",
              fontWeight: "bold",
              mb: 3,
              color: "primary.main",
            },
            "& h2": {
              fontSize: "1.5rem",
              fontWeight: "bold",
              mt: 4,
              mb: 2,
              color: "text.primary",
            },
            "& p": {
              mb: 2,
              lineHeight: 1.7,
              color: "text.secondary",
            },
            "& ul": {
              mb: 2,
              pl: 3,
              "& li": {
                mb: 1,
                color: "text.secondary",
              },
              "& ul": {
                mt: 1,
                mb: 0,
              },
            },
          }}
        >
          {policy && (
            <>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 3, fontStyle: "italic" }}
              >
                Last updated:{" "}
                {new Date(policy.lastUpdated).toLocaleDateString()}{" "}
                {policy.version && `(Version ${policy.version})`}
              </Typography>
              <Box dangerouslySetInnerHTML={{ __html: policy.content }} />
            </>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
